<template>
    <div style="display: flex; flex-direction: column; gap: 50px; margin-top: 16px">
        <div class="large-checkbox">
            <el-checkbox :label="optionLabel" v-model="tab_form.is_active" @change="setOptionPrice"></el-checkbox>
        </div>

        <template v-if="tab_form.is_active">
            <!-- Driver selection (JobAdviser + Multi-Carrier) is only available on the Custom plan -->
            <template v-if="number === 4">
                <el-row :gutter="20" style="font-size: 1.3em; margin: 10px 0;">
                    <template v-for="(equipmentBasedPlan, index) in tab_form.equipment_based_plans">
                        <proposal-tab-pricing-option-ja
                            :equipment_based_plan="equipmentBasedPlan"
                            :index="index"
                            :key="index"
                        />
                    </template>
                </el-row>

                <el-row :gutter="20" style="font-size: 1.3em; margin: 10px 0;">
                    <el-col :span="8">
                        <h2>COMPANY DRIVER MULTI-CARRIER</h2>
                        <template v-if="results.display_driverboost_cd">
                            <p>Available: {{ results.mc_available.count_cd }} at ${{ results.mc_plans.cd[0].price }}/each</p>

                            <el-radio-group :value="mc_leads" @input="setMcLeads">
                                <div v-for="(plan, index) in results.mc_plans.cd" :key="index">
                                    <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                                </div>
                                <div>
                                    <el-radio label="custom">
                                    <el-input v-model="custom_mc_cd_leads" style="width: 100px;" /> leads
                                    <template v-if="custom_mc_cd_leads">
                                        (+ {{ money(parseInt(custom_mc_cd_leads) * mc_lead_price, 0) }})
                                    </template>
                                    </el-radio><br>
                                </div>
                            </el-radio-group>
                        </template>
                    </el-col>
                    <el-col :span="8">
                        <h2>OO &amp; LEASE PURCHASE MULTI-CARRIER</h2>

                        <template  v-if="results.display_driverboost_oo">
                            <p>Available: {{ results.mc_available.count_oo }} at ${{ results.mc_plans.oo[0].price }}/each</p>

                        <el-radio-group :value="mc_oo_leads" @input="setMcOOLeads">
                                <div v-for="(plan, index) in results.mc_plans.oo" :key="index">
                                    <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                                </div>
                            <div>
                                <el-radio label="custom">
                                    <el-input v-model="custom_mc_oo_leads" style="width: 100px;" /> leads
                                    <template v-if="custom_mc_oo_leads">
                                        (+ {{ money(parseInt(custom_mc_oo_leads) * mc_oo_lead_price, 0) }})
                                    </template>
                                </el-radio><br>
                            </div>
                            </el-radio-group>
                        </template>
                    </el-col>
                    <el-col :span="8">
                        <h2>INEXPERIENCED DRIVER MULTI-CARRIER</h2>

                        <template  v-if="results.display_driverboost_student">
                            <p>Available: {{ results.mc_available.count_student }} at ${{ results.mc_plans.student[0].price }}/each</p>

                            <el-radio-group :value="mc_student_leads" @input="setMcStudentLeads">
                                <div v-for="(plan, index) in results.mc_plans.student" :key="index">
                                    <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                                </div>
                                <div>
                                    <el-radio label="custom">
                                        <el-input v-model="custom_mc_student_leads" style="width: 100px;" /> leads
                                        <template v-if="custom_mc_student_leads">
                                            (+ {{ money(parseInt(custom_mc_student_leads) * mc_student_lead_price, 0) }})
                                        </template>
                                    </el-radio><br>
                                </div>
                            </el-radio-group>
                        </template>
                    </el-col>
                </el-row>
            </template>

            <el-row :gutter="20" v-if="number !== 4">
                <el-col :span="24">
                    <h2>ESTIMATED LEADS</h2>
                    <el-input v-model="tab_form.leads_minimum" type="number" style="width:250px;" />
                    <p>Shown on the plan card as "Estimated {{ tab_form.leads_minimum }}+ Leads".</p>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>CUSTOM BUDGET</h2>
                    <el-checkbox v-model="tab_form.is_custom_budget_active">
                        <el-input v-model="tab_form.custom_budget" type="number" style="width:250px;">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-checkbox>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>CUSTOM ADD-ON</h2>
                    <p>Optional extra budget + note. Shown as an extra line on the plan card; the budget is added to the price.</p>
                    <el-input v-model="tab_form.addon_budget" type="number" style="width:250px;">
                        <template slot="prepend">$</template>
                    </el-input>
                    <el-input
                        v-model="tab_form.addon_text"
                        type="textarea"
                        :rows="2"
                        placeholder="Add-on description (optional)"
                        style="margin-top:10px; max-width:600px;"
                    />
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>TOTAL: {{ money(total) }}</h2>

                    <template v-if="number === 4">
                        <p>Gets uncapped job board, {{ allDejaLeads == 0 ? 'no' : allDejaLeads }} DEJA leads, {{ allMcLeads == 0 ? 'no' : allMcLeads }} MC.</p>

                        <p v-if="hireEstimate == 0">No hire estimate.</p>
                        <p v-if="hireEstimate > 0">Estimated hires: {{ hireEstimate }} per month.</p>
                    </template>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <h2>OPTION TEXT</h2>
                    <froala tag="textarea" :config="froalaConfig" v-model="tab_form.description" />
                </el-col>
                <el-col :span="12">
                    <proposal-preview-pricing-option
                        :form_data="form_data"
                        :number="number"
                        :visible="active_tab === 'option' + number"
                    />
                </el-col>
            </el-row>
        </template>
    </div>
</template>

<script>
import ProposalTabPricingOptionJa from './proposal-tab-pricing-option-ja.vue';
import ProposalPreviewPricingOption from './../preview/proposal-preview-pricing-option.vue';

export default {
    components: {
        ProposalTabPricingOptionJa,
        ProposalPreviewPricingOption,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        },
        tab_form: {
            type: Object,
            required: true
        },
        form_data: {
            type: Object,
            required: true
        },
        results: {
            type: Object,
            required: true
        },
        number: {
            type: Number,
            required: true
        },
        active_tab: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,

            custom_mc_cd_leads: this.tab_form.mc_leads,
            custom_mc_oo_leads: this.tab_form.mc_oo_leads,
            custom_mc_student_leads: this.tab_form.mc_student_leads,

            froalaConfig: {
                key: 'CA4D4A2D3E1D2tA6B4B3A1C7D1G2E1E4A3oa2Pe2HTPYh1RNc2E1KDc1==',
                charCounterCount: false,
                height: 200,
                placeholderText: '',
                enter: $.FroalaEditor.ENTER_P,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', '|',  'html'],
                htmlAllowedTags: ['strong', 'b', 'i', 'em', 'u', 's', 'br', 'p'],

                // always clean on Word paste (not giving a choice)
                wordPasteModal: false,
                wordPasteKeepFormatting: false,
            }
        }
    },
    watch: {
        total() {
            this.setOptionPrice();
        },
        custom_mc_cd_leads() {
            this.setMcLeads('custom');
        },
        custom_mc_oo_leads() {
            this.setMcOOLeads('custom');
        },
        custom_mc_student_leads() {
            this.setMcStudentLeads('custom');
        },
    },
    computed: {
        optionLabel() {
            return (this.tab_form.name || ("Option " + this.number)) + " Enabled";
        },
        mc_leads() {
            let options = _.map(this.results.mc_plans.cd, (plan) => plan.leads);
            return (options.includes(this.tab_form.mc_leads))
              ? this.tab_form.mc_leads
              : 'custom';
        },
        mc_lead_price() {
          let prices = _.map(this.results.mc_plans.cd, (plan) => plan.price);
          return prices[0];
        },
        mc_oo_leads() {
          let options = _.map(this.results.mc_plans.oo, (plan) => plan.leads);
          return (options.includes(this.tab_form.mc_oo_leads))
              ? this.tab_form.mc_oo_leads
              : 'custom';
        },
        mc_oo_lead_price() {
          let prices = _.map(this.results.mc_plans.oo, (plan) => plan.price);
          return prices[0];
        },
        mc_student_leads() {
          let options = _.map(this.results.mc_plans.student, (plan) => plan.leads);
          return (options.includes(this.tab_form.mc_student_leads))
              ? this.tab_form.mc_student_leads
              : 'custom';
        },
        mc_student_lead_price() {
          let prices = _.map(this.results.mc_plans.student, (plan) => plan.price);
          return prices[0];
        },
        allDejaLeads() {
            if (this.tab_form.equipment_based_plans) {
                return _.sum(_.map(this.tab_form.equipment_based_plans, (plan) => plan.leads));
            }
            return 0;
        },
        allMcLeads() {
            return this.tab_form.mc_leads + this.tab_form.mc_oo_leads + this.tab_form.mc_student_leads;
        },
        hireEstimate() {
            return this.allDejaLeads / 50;
        },
        totalDriverBoost() {
            if (this.tab_form.equipment_based_plans) {
                return _.sum(_.map(this.tab_form.equipment_based_plans, (plan) => plan.leads * plan.price));
            }
            return 0;
        },
        totalMultiCarrier() {
            return  this.tab_form.mc_leads * this.mc_lead_price
                + this.tab_form.mc_oo_leads * this.mc_oo_lead_price
                + this.tab_form.mc_student_leads * this.mc_student_lead_price
        },
        total() {
            let defaultBudget = parseInt(this.tab_form.default_price) || 0;
            let customBudget = parseInt(this.tab_form.custom_budget) || 0;

            let budget = this.tab_form.is_custom_budget_active ? customBudget : defaultBudget;
            let addon = parseInt(this.tab_form.addon_budget) || 0;

            // Custom plan (option 4) is priced from the selected drivers; plans 1-3 use the plan/custom budget.
            if (this.number === 4) {
                return budget + this.totalMultiCarrier + this.totalDriverBoost + addon;
            }

            return budget + addon;
        }
    },
    methods: {
        setOptionPrice() {
            this.tab_form.price = this.total;
        },
        setMcLeads(value) {
            if (value == 'custom') {
                this.tab_form.mc_leads = parseInt(this.custom_mc_cd_leads) || 0;
            }
            else {
                this.tab_form.mc_leads = value;
            }
        },
        setMcOOLeads(value) {
          if (value == 'custom') {
            this.tab_form.mc_oo_leads = parseInt(this.custom_mc_oo_leads) || 0;
          }
          else {
            this.tab_form.mc_oo_leads = value;
          }
        },
        setMcStudentLeads(value) {
          if (value == 'custom') {
            this.tab_form.mc_student_leads = parseInt(this.custom_mc_student_leads) || 0;
          }
          else {
            this.tab_form.mc_student_leads = value;
          }
        },
        leadsPlanName(leads, price) {
            return leads ? leads+' leads (+'+this.money(leads * price, 0)+')' : 'no Driver Boost';
        },
    }
}
</script>
